import { syncedStore, getYjsValue } from "@syncedstore/core";
import { WebsocketProvider } from "y-websocket";
import * as Y from "yjs";
import { PARTY_USER_STATE } from "../../core/constants";
import { getDomainCfg } from "../../core/state";
import { getComponentData, setComponentData } from "../../core/views";

// Export the provider's awareness API
export let provider : WebsocketProvider;
export let awareness;
export const doc = new Y.Doc()

export const names = ['Wurmig', 'TeePotter', 'WarmArm', 'Einhörnchen', 'Coder', 'Bobby', 'Floppy', 'Nano', 'Zocker', 'Haarig', 'Hacker']

// (optional, define types for TypeScript)
type ChatMessage = { user : string, color : string, msg : string};
type PartyState = { switch: boolean, code : string, messages : ChatMessage[] };

// Create your SyncedStore store
export const syncedDataStore = syncedStore({ partyData: { } as PartyState, fragment: "xml" }, doc);

export const isConnectedToParty = () => {
  if (!getDomainCfg().viewSettings.features.collaborationEnabled) return false;
  return ((provider && awareness) && provider.wsconnected) !== undefined
}

export const setupPartyProvider = (user) => {
  const partyState = getComponentData(PARTY_USER_STATE);
  if (provider && awareness) {
    provider.connect()
  }
  // Create a websocket provider
  provider = new WebsocketProvider(
    getDomainCfg().serverSettings.partyWebSocketServer,
    user.room,
    doc as any
  );

  provider.on('status', event => {
    const partyState = getComponentData(PARTY_USER_STATE);

    //console.log("status changed", event.status, awareness) // logs "connected" or "disconnected"
    const newPartyState = {
      ...partyState,
      connected : provider.wsconnected,
      status: event.status,
      clientID : awareness.clientID
    }
    setComponentData(PARTY_USER_STATE, newPartyState);
    if (event.status === "connected") {
      updateLocalUser(newPartyState)
    }
  })

  awareness = provider.awareness;

  provider.awareness.on('update', update => {
    updateOtherUsers(awareness.getStates())
  })

  const newPartyState = {
    ...partyState,
    name : user.name,
    color : user.color,
    room : provider.roomname,
    connected : provider.wsconnected,
    status: "initialized"
  }
  setComponentData(PARTY_USER_STATE, newPartyState);
}

export const updateLocalUser = (partyState) => {
  console.log('try updated local user', partyState)
  if (!isConnectedToParty()) return;

  awareness.setLocalStateField('user', {
    // Define a print name that should be displayed
    name: partyState.name,
    // Define a color that should be associated to the user:
    color: partyState.color // should be a hex color
  })

  //console.log('updated local user', awareness.getLocalState())
}

const updateOtherUsers = (others) => {
  //console.log('got an update for others', others)
}

export const leaveParty = () => {
  if (!isConnectedToParty()) return;
  provider.disconnect();
}

